module.exports = __webpack_public_path__ + "static/media/rewards-hourglass.cb8010fb.svg";